import styled from 'styled-components';

export const Triangle = styled.div`
  border-bottom: 10px solid #ffffff;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 0;
  font-size: 0;
  height: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  top: -10px;
  right: calc(calc(100% / 2) - 10px);
  width: 0;
  &:after {
    position: relative;
    content: '';
    display: block;
    width: 0;
    height: 0;
    top: 0;
    left: -10px;
    z-index: -1;
    border-bottom: 10px solid #b9b9b9;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }
`;
